import {
  CompanyAction,
  SET_LOADING_ACCOUNTING_INTEGRATION,
  STORE_COMPANY,
  STORE_COMPANY_ACCOUNTING_INTEGRATION,
  STORE_COMPANY_CUSTOM_ONBOARDING_CHECKLIST,
  STORE_COMPANY_POLICY
} from '@Actions/company';

import { IAccountingConnectionModel, ICompanyModel, ICompanyPolicyModel } from '@Shared/models';

interface ICompanyState {
  company: ICompanyModel;
  policy?: ICompanyPolicyModel;
  accountingIntegration?: IAccountingConnectionModel;
  loadingAccountingIntegration?: boolean;
}
export function companyReducer(
  state: ICompanyState = { company: (window.AbacusDataManagerSeed && window.AbacusDataManagerSeed.org) || window.ORG },
  action: CompanyAction
) {
  switch (action.type) {
    case STORE_COMPANY:
      return { ...state, company: { ...state.company, ...action.company } };
    case STORE_COMPANY_POLICY:
      return { ...state, policy: action.companyPolicy };
    case STORE_COMPANY_ACCOUNTING_INTEGRATION:
      return { ...state, accountingIntegration: action.accountingIntegration };
    case SET_LOADING_ACCOUNTING_INTEGRATION:
      return { ...state, loadingAccountingIntegration: action.loading };
    case STORE_COMPANY_CUSTOM_ONBOARDING_CHECKLIST:
      return { ...state, company: { ...state.company, custom_onboarding_checklist: action.customOnboardingChecklist } };
    default:
      return state;
  }
}
